import React from 'react';
import { TrendingUp, DollarSign, Target, BarChart, Layers } from 'lucide-react';

const ConsultantsKPIs = () => {
  const reasons = [
    { icon: TrendingUp, text: 'Scale delivery without scaling labor' },
    { icon: DollarSign, text: 'Increase recurring revenue' },
    { icon: Target, text: 'Differentiate in crowded markets' },
    { icon: BarChart, text: 'Deliver measurable client outcomes' },
    { icon: Layers, text: 'Operate like a platform — not a practice' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Why Consultants Choose <span className="text-cyan-400">Traain</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {reasons.map((reason, index) => {
              const Icon = reason.icon;
              return (
                <div
                  key={index}
                  className={`p-6 rounded-xl bg-gradient-to-br from-gray-800/50 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 ${
                    index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''
                  }`}
                >
                  <Icon className="w-10 h-10 text-cyan-400 mb-4" />
                  <p className="text-lg text-gray-300">{reason.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultantsKPIs;
